export function CardSimple({ children, otherClass }) {

    return (
        <div className={`card rounded-2 p-3 overflow-hidden  ${otherClass}`}>
            {children}
        </div>
    );
}